import React, { FC } from 'react';
import cns from 'classnames';

interface PreloaderProps {
  styles?: object;
}

export const Preloader: FC<PreloaderProps> = ({ styles = {} }) => {
  const { preloader }: { preloader?: any } = styles;

  return (
    <div className={cns('preloader-container')}>
      <div
        // className={`${isLoaded ? 'custom-preloader' : 'default-preloader'}`}
        className="default-preloader"
        style={
          preloader && {
            borderLeft: `${preloader.thickness}px solid ${preloader.color}`,
            fontSize: `${preloader.thickness}px`,
            animation: `svg-ring ${1 / preloader.speed}s cubic-bezier(0.5, 0, 0.5, 1) infinite`,
            width: `${preloader.size}px`,
            height: `${preloader.size}px`,
          }
        }
      />
    </div>
  );
};
